'use client';
import { useTranslations as useTranslations$1 } from 'next-intl';
import Image from 'next/image';
import { ArrowRight, ExternalLink } from '@/components/ui/icons';
import { FEATURED_FILMS } from '@/lib/marketing-config';
export function FilmGallery() {
    const t = useTranslations$1();
    return (<div className="flex flex-col items-center">
      <div className="stagger-children grid w-full grid-cols-1 gap-8 md:grid-cols-2 md:gap-10 lg:grid-cols-3 lg:gap-12">
        {FEATURED_FILMS.map((film, index)=>(<div key={film.id} className="animate-on-scroll group" style={{
            transitionDelay: `${index * 100}ms`
        }}>
            { /* Image container - links to film */ }
            <a href={film.filmUrl} target="_blank" rel="noopener noreferrer" className="block cursor-pointer">
              <div className="relative mb-5 overflow-hidden rounded-xl">
                <div className="transition-transform duration-500 ease-out group-hover:scale-[1.02]">
                  <Image src={film.thumbnail} alt={`${film.title} - film by ${film.creator}`} width={800} height={340} className="aspect-[2.35/1] w-full object-cover transition-opacity duration-500 group-hover:opacity-90"/>
                </div>
                { /* Subtle overlay on hover */ }
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"/>
                { /* View Film indicator */ }
                <div className="absolute bottom-4 end-4 translate-y-1 transform opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  <div className="flex items-center gap-2 rounded-full bg-white/90 px-3 py-1.5 text-xs font-medium text-black backdrop-blur-sm">
                    View Film
                    <ArrowRight className="h-3 w-3"/>
                  </div>
                </div>
              </div>
            </a>

            { /* Title - links to film */ }
            <a href={film.filmUrl} target="_blank" rel="noopener noreferrer">
              <h3 className="mb-2 text-xl font-bold text-white transition-colors duration-200 group-hover:text-white/90">
                {film.title}
              </h3>
            </a>
            { /* Creator - separate link */ }
            <p className="text-sm text-zinc-400">
              by{' '}
              <a href={film.creatorUrl} target="_blank" rel="noopener noreferrer" className="font-medium text-white/80 transition-colors duration-200 hover:text-white hover:underline">
                {film.creator}
              </a>
            </p>
          </div>))}
      </div>

      { /* See More Button */ }
      <a href="https://madewithmartini.com" target="_blank" rel="noopener noreferrer" className="group/btn relative mt-12 inline-flex items-center gap-2.5 overflow-hidden rounded-full px-7 py-3.5 text-sm font-medium text-white/80 transition-all duration-300 ease-out hover:text-white md:mt-16">
        { /* Subtle gradient background */ }
        <span className="absolute inset-0 rounded-full bg-gradient-to-r from-white/[0.08] via-white/[0.04] to-white/[0.08] transition-all duration-300 group-hover/btn:from-white/[0.12] group-hover/btn:via-white/[0.08] group-hover/btn:to-white/[0.12]"/>
        { /* Border */ }
        <span className="absolute inset-0 rounded-full border border-white/10 transition-all duration-300 group-hover/btn:border-white/20"/>
        { /* Content */ }
        <span className="relative">{t("uCl14P", {
        site: 'MadeWithMartini.com'
    })}</span>
        <ExternalLink className="relative h-4 w-4 transition-transform duration-300 ease-out group-hover/btn:translate-x-0.5"/>
      </a>
    </div>);
}
